module.exports = __webpack_public_path__ + "static/media/basketball-icon.7d3fefea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/basketball-icon.svg
// module id = 37
// module chunks = 0